import { render, staticRenderFns } from "./TheSignatureRecalled.vue?vue&type=template&id=31e45a36&scoped=true&"
import script from "./TheSignatureRecalled.vue?vue&type=script&lang=js&"
export * from "./TheSignatureRecalled.vue?vue&type=script&lang=js&"
import style0 from "./TheSignatureRecalled.vue?vue&type=style&index=0&id=31e45a36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e45a36",
  null
  
)

export default component.exports